import React from 'react';
import ReactDOM from 'react-dom';
import ReactPlayer from 'react-player';
import { makeStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import GridListTileBar from '@material-ui/core/GridListTileBar';
import iconPath from "./../../../helpers/iconHelper";
import Imagemodal from './Imagemodal';
import IconButton from '@material-ui/core/IconButton';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import LightboxExample from "./lightbox";
import App from './demo/App';
import $ from "jquery";

import './FeedImage.css';


const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
}));

const Gridlist = (props) => { 
    let {media_details,dynamic_class,setActiveImage,currentFeed,currentActiveImage,carousalFeed} = props;


    const seeMore   = (media_details.length) - 3;
    const totalMedia= (media_details.length);
     if(media_details.length > 3){
      media_details = media_details.slice(0, 3);
    } 
    let imageIndex = 0;
    const classes   = useStyles();
    const innerHght = $("#post_img").innerHeight();
    const innerWdth = `${$("#post_img").innerWidth()}px !important`;
    let iteration = 0;
    const setImageindex = (index) => {
        props.toggleLightbox(index)
    }

    
    return (
    <div>
     
      <div className="post_img" >
     
        {
          (media_details.length <= 1)?
             media_details.map((tile,index) => {  
                 
                  return (
                    (tile.media_type == 'IMAGE') ? 
                    <img src={tile.media_link} alt={tile.media_link}  
                         key={tile.gallery_id} 
                         onError = {(e) => {
                            e.target.src = iconPath['BREAKIMAGE']
                         }} 
                         onClick={()=>setImageindex(index)}
                         className="single-image"
                    />
                    
                    : 
                      <video src={tile.media_link} 
                             key={tile.gallery_id} 
                             onClick={()=>setImageindex(index)} 
                             controls 
                             controlsList="nodownload">
                     
                      </video> 
                  )
              })
            :  
              <GridList cellHeight={innerHght} width={innerWdth} cols={2}>
              {media_details.map((tile,index) => {
              
                return(  
                <GridListTile key={tile.gallery_id} cols={((index == 0) && (totalMedia >= 3)) ? 2 : 1} rows={((index == 0) && (totalMedia >= 3)) ? 2 : 1}>
                 
                  <img src={tile.media_type == 'VIDEO' ? tile.media_link_thumbnail : tile.media_link} alt={tile.media_link}  
                    onError = {(e) => {
                      e.target.src = iconPath['BREAKIMAGE']
                    }} onClick={()=>setImageindex(index)}
                    
                  />
                  
                  {
                    ((index == 2) && (totalMedia > 3)) ? 
                    <GridListTileBar height={`${innerHght}px`}
                    title={`+${seeMore}`}
                    className="customTitleBar" onClick={()=>setImageindex(index)}/>
                    : null
                  }

                  {
                    ((index == 0) && (tile.media_type == 'VIDEO')) ? 
                    <GridListTileBar 
                    actionIcon={
                      <IconButton aria-label="play/pause">
                          <PlayArrowIcon className={classes.playIcon} />
                      </IconButton>
                    }
                    style={{color : 'white'}}
                    className="customPlayIcon" 
                    onClick={()=>setImageindex(index)}/>
                    : null
                  }
                </GridListTile>
                )
                })}
              </GridList>
          }
          
      </div>
      
      </div>
    );
};
export default Gridlist;